export default __webpack_public_path__ + "static/media/Path2253.2bcfb7a6.svg";